module.exports = __webpack_public_path__ + "media/images/am-2cf377ec775ee4a259ffe1d613524c03.png";